var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiltersImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.11206H9.42346V2.55804H0V4.11206ZM11.1368 0C10.8774 0.0381223 10.643 0.175637 10.4831 0.383469C10.3232 0.591302 10.2504 0.853161 10.2801 1.11368V5.5607C10.2504 5.82122 10.3232 6.08308 10.4831 6.29091C10.643 6.49875 10.8774 6.63626 11.1368 6.67438C11.3962 6.63626 11.6307 6.49875 11.7905 6.29091C11.9504 6.08308 12.0232 5.82122 11.9935 5.5607V1.11368C12.0232 0.853161 11.9504 0.591302 11.7905 0.383469C11.6307 0.175637 11.3962 0.0381223 11.1368 0ZM5.99675 9.23071V7.78464C6.02645 7.52412 5.95366 7.26226 5.79379 7.05443C5.63392 6.84659 5.39949 6.70908 5.14007 6.67096C4.88065 6.70908 4.64622 6.84659 4.48635 7.05443C4.32648 7.26226 4.2537 7.52412 4.28339 7.78464V12.2334C4.2537 12.4939 4.32648 12.7557 4.48635 12.9636C4.64622 13.1714 4.88065 13.3089 5.14007 13.3471C5.39949 13.3089 5.63392 13.1714 5.79379 12.9636C5.95366 12.7557 6.02645 12.4939 5.99675 12.2334V10.7873H11.9935V9.23071H5.99675ZM0 10.7873H3.42671V9.23071H0V10.7873Z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersImage);
export default __webpack_public_path__ + "static/media/filters-image.c7277bbd1a58b7affabce4ec601ff191.svg";
export { ForwardRef as ReactComponent };